import type { SVGProps } from "react";

/**
 * ar-cube-3
 * @category Augmented Reality
 */
export default function IconArCube3(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9.48045 4.13599L11.5097 2.99451C11.8142 2.82328 12.1858 2.82328 12.4903 2.99451L14.5196 4.13599M17.5703 5.85201L19.7403 7.07264C20.0551 7.24976 20.25 7.58294 20.25 7.94421V10.25M20.25 13.75V16.0558C20.25 16.417 20.0551 16.7502 19.7403 16.9273L17.5703 18.148M14.5196 19.864L12.4903 21.0055C12.1858 21.1767 11.8142 21.1767 11.5097 21.0055L9.48044 19.864M6.42973 18.148L4.25974 16.9273C3.94486 16.7502 3.75 16.417 3.75 16.0558V13.75M3.75 10.25V7.94421C3.75 7.58294 3.94486 7.24976 4.25974 7.07264L6.42974 5.85201M12 14.25V12M12 12L13.9485 10.875M12 12L10.0514 10.875M12 3.21874V6.24999M12 17.7031V20.7812M6.84875 14.8516L4.13406 16.4189M4.13406 7.58111L6.80815 9.12499M19.8659 7.58111L17.1918 9.12499M17.1513 14.8516L19.8659 16.4189'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
